import {
  LOAD_INFO,
  LOAD_INFO_SUCCESS,
  LOAD_INFO_FAILURE,
  SET_AUTH_METHOD,
  InfoActionTypes,
} from "./info.types";
import { InfoData } from "@sportal/api";
import { LoadingState } from "../shared/withLoadableSlice.types";
import { LOGIN_FAILURE } from "../../pages/login/login.actions";
import { withLoadingState } from "../shared";

export type InfoState = InfoData & LoadingState;

export const initialState = {} as InfoState;

type InfoReducerActionTypes =
  | InfoActionTypes
  | { type: typeof LOGIN_FAILURE; payload: any };

const reducer = (
  state: InfoState = initialState,
  action: InfoReducerActionTypes
): InfoState => {
  switch (action.type) {
    case LOAD_INFO_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SET_AUTH_METHOD:
      return {
        ...state,
        authMethod: action.payload,
      };
    default:
      return state;
  }
};

export const subscriberInfoReducer = withLoadingState({
  loadActionType: LOAD_INFO,
  successActionType: LOAD_INFO_SUCCESS,
  failureActionType: LOAD_INFO_FAILURE,
})(reducer);
